import { render, staticRenderFns } from "./HouseholdNewton.vue?vue&type=template&id=490ae2ea&scoped=true&"
import script from "./HouseholdNewton.vue?vue&type=script&lang=js&"
export * from "./HouseholdNewton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490ae2ea",
  null
  
)

export default component.exports